/**
 * Преобразование параметров в строку для поиска
 * @param request - строка запроса
 * @param country - страна
 * @param region - регион
 * @param city - город
 */
export const serializeToRequest = (
  request: string,
  country: string,
  region: string,
  city: string,
): string => {
  let fullRequest = request

  if (city === 'Адлер') {
    return (fullRequest = `${country}, ${region}, Сочи, ${fullRequest}`)
  }

  if (region) {
    const stateReg = new RegExp(region, 'gi')

    if (request.search(stateReg) === -1)
      fullRequest = `${region}, ${fullRequest}`
  }

  if (city) {
    const cityReg = new RegExp(city, 'gi')

    if (request.search(cityReg) === -1) fullRequest = `${city}, ${fullRequest}`
  }

  if (country) {
    const countryReg = new RegExp(country, 'gi')

    if (request.search(countryReg) === -1)
      fullRequest = `${country}, ${fullRequest}`
  }

  return fullRequest
}
